import { DataBean } from "../DataBean";

export class Reprovision extends DataBean {

    public async recalculateEmployeeProvisions(idContract: any, year: any, month: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_recalculateEmployeeProvisions_Number_Number_Number", [idContract, year, month]);
    }

}